import React, { useEffect, useState } from "react";
import { 
    Flex,
    Circle,
    Box,
    Image,
    Icon,
    chakra,
    Tooltip,
    Text,
    VStack
} from "@chakra-ui/react";
import axios from 'axios';
import { FiShoppingCart } from 'react-icons/fi';
import CommonVars from "../components/CommonVars";

function Products () {
    const [products, setProducts] = useState([]);

    // get all products from server
    const getProducts = async () => {
        axios.get(`${CommonVars.API_URL}/products`)
        .then((res) => {
            // console.log(res.data);
            setProducts(res.data);
        })
        .catch((err) => {
            console.log(err);
        })
    }

    useEffect(() => {
        getProducts();
    }, []);

    const aProducts = [];

    for (var i = 0; i < products.length; i++) {   
        aProducts.push(
            <Box
                key={products[i].productid}
                borderWidth="1px"
                rounded="lg"
                shadow="lg"
                position="relative"
                width="auto"
            >
                <Circle
                    size="10px"
                    position="absolute"
                    top={2}
                    right={2}
                    bg="red.200"
                />

                <a href={'/products/' + products[i].productid}>
                    <Image
                        boxSize="290px"
                        src={products[i].products_img_url}
                        alt={`Picture of ${products[i].name}`}
                        roundedTop="lg"
                        mx="auto"
                        _hover={{ transform: "scale(1.05)" }} transition={"1s ease-in-out"}
                    />
                </a>

                <Box p="5">
                    <Flex mt="1" justifyContent="space-between" alignContent="center">
                        <Box
                            fontSize="xl"
                            fontWeight="semibold"
                            as="h4"
                            lineHeight="tight"
                            istruncated="true"
                        >
                            <chakra.a href={'/products/' + products[i].productid} display={'flex'}>
                                {products[i].name}
                            </chakra.a>
                        </Box>
                        <Tooltip
                            label="Add to cart"
                            bg="white"
                            placement={'top'}
                            color={'gray.800'}
                            fontSize={'1.2em'}
                        >
                            <chakra.a href={'/products/' + products[i].productid} display={'flex'}>
                                <Icon as={FiShoppingCart} h={6} w={6} alignSelf={'center'} />
                            </chakra.a>
                        </Tooltip>
                    </Flex>

                    <VStack align={'left'}>
                        <Box fontSize="xl">
                            <Text>${products[i].price}</Text>
                        </Box>
                    </VStack>
                </Box>
            </Box>
        )
    }
    return aProducts;
}

export default Products;